// §6.1 — the macOS skin: the third implementation, and the one that stresses the parts of the
// contract the first two agreed about.
//
// Two of them in particular:
//
//   • **The menu protocol.** §9.3 makes a published tree belong to a *window instance*. The other
//     two skins draw it inside that window, so nothing ever tested whether the tree could be read
//     from somewhere else. Here it is a global bar that swaps on focus — the same service, the same
//     tree, a different consumer.
//   • **Spaces.** §5.4 lets a skin decide what the maximize button means, and this is the only skin
//     that answers `enterFullscreenSpace` (D-032). §5.5's desktops were built for the Windows
//     skin's Task View; this skin uses the same primitive for something that looks nothing like it.
//
// Nothing here imports another skin (§6.5, enforced by lint and by the arch test).
import type { UiSkin } from '../contract';
import tokens from './tokens.css?inline';
import './skin.css';
import { macosKeymap } from './keymap';
import { macosPolicy } from './policy';
import { macosSounds } from './sounds';
import { WindowFrame } from './components/WindowFrame';
import { DesktopSurface } from './components/DesktopSurface';
import { Bar } from './components/Bar';
import { Launcher } from './components/Launcher';
import { Dialog } from './components/Dialog';
import { Switcher } from './components/Switcher';
import { LockScreen, LoginScreen, NotificationHost, TrayFlyout } from './components/misc';

export const macosSkin: UiSkin = {
  id: 'macos',
  label: 'macOS',
  tokens,
  keymap: macosKeymap,
  policy: macosPolicy,
  sounds: macosSounds,
  components: {
    DesktopSurface,
    Bar,
    Launcher,
    WindowFrame,
    Dialog,
    NotificationHost,
    Switcher,
    TrayFlyout,
    LoginScreen,
    LockScreen,
  },
};
